function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#828898",
  d: "M11.348 23.363c6.21 0 11.355-5.144 11.355-11.367 0-6.21-5.156-11.355-11.367-11.355C5.125.64-.02 5.785-.02 11.996c0 6.223 5.157 11.367 11.368 11.367zm0-2.027c-5.18 0-9.328-4.148-9.328-9.34 0-5.18 4.136-9.34 9.316-9.34 5.18 0 9.34 4.16 9.352 9.34.011 5.191-4.16 9.34-9.34 9.34zm-.235-7.078c.575 0 .926-.352.938-.785v-.141c.011-.598.386-.996 1.136-1.488 1.09-.703 1.829-1.36 1.829-2.66 0-1.852-1.641-2.86-3.563-2.86-1.898 0-3.164.89-3.48 1.91-.07.188-.106.375-.106.563 0 .504.41.797.82.797.633 0 .75-.328 1.102-.739.363-.585.879-.937 1.582-.937.973 0 1.594.55 1.594 1.36 0 .726-.457 1.09-1.418 1.757-.797.55-1.383 1.137-1.383 2.192v.128c0 .598.34.903.95.903zm-.023 3.34c.656 0 1.23-.504 1.23-1.172 0-.668-.562-1.172-1.23-1.172-.68 0-1.23.516-1.23 1.172 0 .656.562 1.172 1.23 1.172z"
});

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.d99249bc.svg";
export { ForwardRef as ReactComponent };